import { inject, Injectable } from "@angular/core";
import { RealtimeConnection } from "./realtime-connection";

import { Observable, Subject } from "rxjs";
import { DomainDataService } from "../domain-data.service";
import { MapIconService } from "../map-icon.service";
import { SignalRService } from "./signalR.service";

@Injectable({
    providedIn: "root",
})
export class DomainDataRealtimeService {
    private connection: RealtimeConnection;
    private readonly domainDataChangedSubject$ = new Subject<void>();

    private readonly signalRService = inject(SignalRService);
    private readonly mapIconService = inject(MapIconService);
    private readonly domainDataService = inject(DomainDataService);

    subscribe() {
        if (this.connection?.connection) {
            // subscription already there or this is triggered via AppComponent so if there is no authentication we do not load anything
            return;
        }

        const onSuccess = async () => {
            await Promise.all([this.mapIconService.initializeIcons(true), this.domainDataService.reload(true)]);
        };
        const onError = () => {};

        this.onDomainDataChanged$().subscribe({
            next: onSuccess,
            error: onError,
        });

        // we need this connection to be present for the time being of the application
        this.subscribeToSignalR();
    }

    private onDomainDataChanged$(): Observable<void> {
        return this.domainDataChangedSubject$.asObservable();
    }

    private subscribeToSignalR(): void {
        if (this.connection) return;
        // ContextId is not supported for locations, we pass 0
        // Later we might pass the project-id to only get updates about the projects we're looking at
        this.connection = this.signalRService.CreateConnection(null, "/v1/realtime/DomainData");
        this.connection.onRegisterEvents = (c) => {
            c.connection.on("changed", () => {
                this.domainDataChangedSubject$.next();
            });
        };
        this.connection.onDetachEvents = (c) => {
            c.connection.off("changed");
        };
        this.signalRService.startConnection(this.connection);
    }
}
